module.exports = __webpack_public_path__ + "img/bea-payday-logo.85d1390f.png";